export default __webpack_public_path__ + "static/media/kitchen3-before3-768w.1a5fec18.png";